import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resolver } from "../../API/middlewares/resolveRequests";
import { getProfileToggleLists } from "../../API/store/actions/auth";
import { currentCommunity } from "../../API/store/actions/community";
import { Link } from "react-router-dom";
import { ScrollToTop } from "../../algorithms";

const CommunitiesList = ({ id }) => {
  const [data, setData] = useState([]);
  const userToken = useSelector((state) => state.login.userToken);
  const userLogged = useSelector((state) => state.login.userData);
  useEffect(() => {
    if (id)
      resolver(
        getProfileToggleLists,
        setData,
        userLogged.memberId,
        id,
        userToken
      );
    ScrollToTop();
  }, []);

  const dispatch = useDispatch();

  if (data?.data)
    return (
      <div className="d-flex container col-10 py-3 mb-3">
        <div className="d-flex flex-column justify-content-start col-12">
          {data?.data?.map((item, index) => {
            return (
              <Link
                to={`/communityDetails/${item?.id}`}
                key={item.id}
                onClick={() => {
                  dispatch(
                    currentCommunity({
                      id: item?.id,
                      name: item?.name,
                      logo: item?.logo,
                    })
                  );
                }}
                className=" hoverLinks text-decoration-none"
                style={{ width: "fit-content" }}
              >
                <div className="d-flex p-2 align-items-center">
                  <div>
                    <img src={"/assets/images/sync-1.png"} />
                  </div>
                  <div className="mx-2">{item.name}</div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    );
  return <div></div>;
};
export default CommunitiesList;
